import React from 'react';
import { _defineHelpUrlandToolTip } from '../../helpers/index.js'

const ControlsRepeat = function () {
    const name = "controls_repeat_ext";
    ControlsRepeat.blockName = name;

    _defineHelpUrlandToolTip(name,  Blockly.BASE_HELP_URL + "#loops");

    return (
        <block type={name}>
            <value name="TIMES">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
    );
};

export default ControlsRepeat;